export default __webpack_public_path__ + "static/pixel-foundry-50b249c9c4adf088780fc3fc4113e5d9.png";